// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"14964d56","125":"bea214df","477":"a2f4e8b8","486":"5c38fd02","657":"71413ac2","718":"130a82d9","771":"09b53de9","775":"3ee557cf","935":"18dfa8a2","964":"283700c0"}[chunkId] + ".chunk.js";
};